<template>
    <div class="nav-select">
        <el-cascader
                expand-trigger="hover"
                :options="navList"
                @change="navChange"
                v-if="is_Bottom && single"
                :value="value"
                size="mini" />
        <el-cascader
                expand-trigger="hover"
                :options="navList"
                @change="navChange"
                v-if="!is_Bottom && single"
                change-on-select
                :value="value"
                size="mini" />
        <el-cascader
                expand-trigger="hover"
                :options = "navList"
                @change = "navChange"
                :props = "props"
                clearable
                :value = "value"
                :disabled = "disabled"
                v-if="!is_Bottom && !single"
                filterable
                change-on-select
                size="mini" />
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'nav-select',
        props: {
            classId: {
                type: Array
            },
            isBottom: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            single: {
                 type: Boolean,
                 default: true
            }
        },
        data() {
            return {
                props: { multiple: true },
                is_Bottom: this.isBottom, // 是否只选择底层
                navList: [], // 导航列表
                currentNav: '',
                value: this.classId
            };
        },
        created() {
            this.getNavList();
        },
        methods: {
            clearData() {
              this.value = [];
            },
            navChange(data) {
                // 选择导航，重新获取分类
                // let len = data.length - 1;
                // this.currentNav = data[len];
                this.value = data;
                this.$emit('getNav', data);
            },
            getNavList() {
                // 获取导航列表
                this.loading = true;
                this.httpGet(this.$root.getNavList).then(res => {
                    this.totalSize = parseInt(res.count);
                    // 重新组合满足联级条件的navList
                    this.navList = [];
                    let list = res.list;
                    // todo 三级需要优化
                    list.forEach((item, i) => {
                        let data = {
                            value: item.id,
                            label: item.label,
                            children: []
                        };
                        this.navList.push(data);
                        if (item.children.length > 0) {
                            item.children.forEach((item1, j) => {
                                let data1 = {
                                    value: item1.id,
                                    label: item1.label,
                                    children: []
                                };
                                this.navList[i].children.push(data1);
                                if (item1.children.length > 0) {
                                    item1.children.forEach((item2) => {
                                        let data2 = {
                                            value: item2.id,
                                            label: item2.label
                                        };
                                        this.navList[i].children[j].children.push(data2);
                                    });
                                } else {
                                    delete this.navList[i].children[j].children;
                                }
                            });
                        } else {
                            delete this.navList[i].children;
                        }
                    });
                    this.loading = false;
                }, () => {
                    this.loading = false;
                });
            }
        },
        watch: {
            classId(val) {
                this.value = val;
            },
            isBottom(val) {
                this.is_Bottom = val;
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';
    .defaultImg{
        .add{
            font-size 30px
        }
        flex-y(center, center);
        border:1px dashed gray9
        p{
            text-align center
        }
    }
    .single {
        position relative
        flex-x(flex-start)
        background #f5f5f5
        input {
            width: 100%
            height: 100%
            opacity 0
            position absolute
            left: 0
        }
        img {
            width: 100%
            height: 100%
        }
    }
    p{
        float: left;
        width: 150px;
    }
</style>
